import styled from "@emotion/styled";

import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const IconWrapper = styled.div({
    flexShrink: "none",
    marginRight: "4px",
});

export const ListItemWrapper = styled.div(props => ({
    width: "100%",
    fontSize: theme(props).typography.primary.fontSize.css(),
    padding: `10px 40px 10px 8px`,
    boxSizing: "border-box",
    cursor: "default",

    ":hover": {
        backgroundColor: props.theme.candy.lists.items.accentLow.backgroundColor,
    },
}));

export const ListItem = styled.div<{ touched?: boolean }>(
    () => ({
        display: "flex",
        alignItems: "baseline",
        width: "100%",
    }),
    props =>
        props.touched
            ? {
                  color: theme(props).typography.inactive.color,

                  [`${IconWrapper}`]: {
                      color: theme(props).icons.disabledColor,
                  },
              }
            : { cursor: "default" }
);

export const ListItemSource = styled.p({
    marginTop: "5px",
    marginBottom: 0,
});

export const Justification = styled.div(props => ({
    marginTop: theme(props).size(1),
    color: theme(props).typography.secondary.color,
}));

export const JustificationContainer = styled.span(props => ({
    color: theme(props).typography.secondary.color,

    a: {
        color: theme(props).typography.link.color,
        textDecoration: "none",

        ":focus,:hover": {
            textDecoration: "underline",
        },
    },
}));

export const SourceItemLink = styled.span<{ disabled?: boolean }>(
    { textDecoration: "none" },
    props =>
        !props.disabled && {
            color: theme(props).typography.link.color,
            cursor: "pointer",
        }
);

export const FakeIcon = styled.div({
    width: "14px",
});
